var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22222 22C3.61111 22 3.08815 21.7826 2.65333 21.3478C2.21852 20.913 2.00074 20.3896 2 19.7778V4.22222C2 3.61111 2.21778 3.08815 2.65333 2.65333C3.08889 2.21852 3.61185 2.00074 4.22222 2H19.7778C20.3889 2 20.9122 2.21778 21.3478 2.65333C21.7833 3.08889 22.0007 3.61185 22 4.22222V19.7778C22 20.3889 21.7826 20.9122 21.3478 21.3478C20.913 21.7833 20.3896 22.0007 19.7778 22H4.22222ZM12 18.6667C13.7963 17.1481 15.1344 15.7363 16.0144 14.4311C16.8944 13.1259 17.3341 11.9174 17.3333 10.8056C17.3333 9.12037 16.7963 7.78704 15.7222 6.80555C14.6481 5.82407 13.4074 5.33333 12 5.33333C10.5926 5.33333 9.35185 5.82407 8.27778 6.80555C7.2037 7.78704 6.66667 9.12037 6.66667 10.8056C6.66667 11.9167 7.10667 13.1252 7.98667 14.4311C8.86667 15.737 10.2044 17.1489 12 18.6667ZM12 12.2778C11.6111 12.2778 11.2822 12.1433 11.0133 11.8744C10.7444 11.6056 10.6104 11.277 10.6111 10.8889C10.6119 10.5007 10.7463 10.1719 11.0144 9.90222C11.2826 9.63259 11.6111 9.49852 12 9.5C12.3889 9.50148 12.7178 9.63593 12.9867 9.90333C13.2556 10.1707 13.3896 10.4993 13.3889 10.8889C13.3881 11.2785 13.2537 11.6074 12.9856 11.8756C12.7174 12.1437 12.3889 12.2778 12 12.2778Z",
    fill: "#F8604A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnMap);
export default __webpack_public_path__ + "static/media/onMap.06492bfd788dab66200801a8bd994d03.svg";
export { ForwardRef as ReactComponent };